import React, { useEffect, useState } from "react";
import { Row, Col, Tab, Tabs, Form, Card, Button } from "react-bootstrap";
import Avatar from "../../assets/img/default.jpg";
import ConfigApp from "../../common/config";
import { updateProfile, updatePassword ,fileUpload} from "../../common/api";
import { ShowToast } from "../../common/function";
import { Spinner } from "react-activity";

export default function ProfileSettings() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const [currentPassword, setCurrentPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState("");
  const[loading, setLoading] = useState(false);

  const [key, setKey] = useState("basicinfo");

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    setLoading(true);
    if (file) {
      setProfileImage(file);
      setPreview(URL.createObjectURL(file));
  
      const formData = new FormData();
      formData.append("images[]", file); // 'file' should match your backend field
  
      const token = localStorage.getItem("token");
  
      const response = await fileUpload(token, formData); // Your API should accept FormData
  
      if (response.success) {
        setLoading(false);
        setProfileImage(response.body[0]); // Assuming `response.body.file` is the uploaded file URL/path
      } else {
        ShowToast(0, response.message || "File upload failed");
      }
    }
  };
  
  const validateStrongPassword = (password) => {
    const strongPasswordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{6,}$/;
    return strongPasswordRegex.test(password);
  };

  const handleBasicInfoSubmit = async (e) => {
    e.preventDefault();
    let tempErrors = {};
    if (!name.trim()) tempErrors.name = "Please enter name";
    if (!email.trim()) tempErrors.email = "Please enter email address";
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length === 0) {
      const token = localStorage.getItem("token");
      const userData = JSON.parse(localStorage.getItem("userDetail"));
      console.log("profileImage", profileImage);
      setIsLoading(true)
      const response = await updateProfile(token, {
        name,
        email,
        image_url: profileImage,
        adminId: userData.user._id,
      });
      setIsLoading(false)
      if (response.success == true) {
      console.log("response", response);
      localStorage.setItem("userDetail", JSON.stringify(response.body));
        window.location.reload();
        setErrors({});
        ShowToast(1, "Profile updated successfully");
      } else {
        ShowToast(0, response.message);
      }
    }
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    let tempErrors = {};
    if (!currentPassword.trim()) tempErrors.currentPassword = "Enter current password";
    if (!newPassword.trim()) {
      tempErrors.newPassword = "Enter new password";
    } else if (!validateStrongPassword(newPassword)) {
      tempErrors.newPassword =   "Password must be at least 6 characters, include a number and a special character";
    }
    if (!confirmPassword.trim()) {
      tempErrors.confirmPassword = "Confirm new password";
    } else if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length === 0) {
      setIsLoading(true)
      const token = localStorage.getItem("token");
      const userData = JSON.parse(localStorage.getItem("userDetail"));
      const response = await updatePassword(token, {
        oldPassword: currentPassword,
        newPassword,
        adminId: userData.user._id,
      });
      setIsLoading(false)
      if (response.success) {
        setErrors({});
        ShowToast(1, "Password updated successfully");
        console.log("Password updated");
      } else {
        ShowToast(0, response.message);
      }
    }
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userDetail"));
    setName(userData.user.name);
    setEmail(userData.user.email);
    setProfileImage(userData.user.image_url);
  }, []);

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>Profile Settings</h5>
        </Card.Header>
        <Card.Body>
          <Tabs
            defaultActiveKey="basicinfo"
            className="customtabs mb-2"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="basicinfo" title="Basic Info">
              <Row>
                <Col md={5} xl={4} className="view_profile mb-3">
                  <div className="user_info text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      {loading ? <Spinner animation="border" variant="primary" /> :
                      <img
                        src={preview ? preview : profileImage? ConfigApp.IMAGE_URL + profileImage:Avatar}
                        className="rounded-circle img-fluid profilepic"
                        alt="Profile"
                        style={{ width: "120px", height: "120px", objectFit: "cover" }}
                      />
                      }
                    </div>
                    <label
                      htmlFor="uploadprofileimg"
                      className="d-inline-block mt-3 btn btn-primary-outline px-4 font-size-14 lh-40"
                    >
                      Choose Picture
                    </label>
                    <input
                      type="file"
                      id="uploadprofileimg"
                      accept="image/*"
                      className="d-none"
                      onChange={handleImageChange}
                    />
                  </div>
                </Col>
                <Col md={7} xl={8}>
                  <Form onSubmit={handleBasicInfoSubmit}>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              if (errors.name && e.target.value.trim()) {
                                setErrors((prev) => ({ ...prev, name: null }));
                              }
                            }}
                          />
                          {errors.name && <p className="text-danger mt-1">{errors.name}</p>}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Email Address</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter email address"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              if (errors.email && e.target.value.trim()) {
                                setErrors((prev) => ({ ...prev, email: null }));
                              }
                            }}
                          />
                          {errors.email && <p className="text-danger mt-1">{errors.email}</p>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button className="btn btn-primary px-4 mt-3" type="submit" disabled={isLoading}>
                      {isLoading ? (
                        <Spinner animation="border" variant="primary" size={15} />
                      ) : (
                        "Update"
                      )}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="changepassword" title="Change Password">
              <Row>
                <Col md={12} xl={12}>
                  <Form onSubmit={handlePasswordUpdate}>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Current Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Current Password"
                            value={currentPassword}
                            onChange={(e) => {
                              setCurrentPassword(e.target.value);
                              if (errors.currentPassword && e.target.value.trim()) {
                                setErrors((prev) => ({ ...prev, currentPassword: null }));
                              }
                            }}
                          />
                          {errors.currentPassword && (
                            <p className="text-danger mt-1">{errors.currentPassword}</p>
                          )}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>New Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => {
                              setNewPassword(e.target.value);
                              if (
                                errors.newPassword &&
                                validateStrongPassword(e.target.value)
                              ) {
                                setErrors((prev) => ({ ...prev, newPassword: null }));
                              }
                            }}
                          />
                          {errors.newPassword && (
                            <p className="text-danger mt-1">{errors.newPassword}</p>
                          )}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Confirm New Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                              if (
                                errors.confirmPassword &&
                                newPassword === e.target.value
                              ) {
                                setErrors((prev) => ({ ...prev, confirmPassword: null }));
                              }
                            }}
                          />
                          {errors.confirmPassword && (
                            <p className="text-danger mt-1">{errors.confirmPassword}</p>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button className="btn btn-primary px-4 mt-3" type="submit" disabled={isLoading}>
                      {isLoading ? (
                        <Spinner animation="border" variant="primary" size={15} />
                      ) : (
                        "Update"
                      )}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
}
